/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Cropper from "cropperjs";
const __vue_script__ = {
	name: "ImageCropper",
	props: ["file", "fixed_aspect_ratio"],
	data() {
		let aspect_ratio =
			this.fixed_aspect_ratio != null ? this.fixed_aspect_ratio : NaN;
		return {
			src: null,
			cropper: null,
			image: null,
			aspect_ratio
		};
	},
	watch: {
		aspect_ratio(value) {
			if (this.cropper) {
				this.cropper.setAspectRatio(value);
			}
		}
	},
	mounted() {
		if (window.FileReader) {
			let fr = new FileReader();
			fr.onload = () => (this.src = fr.result);
			fr.readAsDataURL(this.file.cropper_file);
		}
		let crop_box = this.file.crop_box_data;
		this.image = this.$refs.image;
		this.image.onload = () => {
			this.cropper = new Cropper(this.image, {
				zoomable: false,
				scalable: false,
				viewMode: 1,
				data: crop_box,
				aspectRatio: this.aspect_ratio
			});
			window.cropper = this.cropper;
		};
	},
	computed: {
		aspect_ratio_buttons() {
			return [
				{
					label: __("1:1"),
					value: 1
				},
				{
					label: __("4:3"),
					value: 4 / 3
				},
				{
					label: __("16:9"),
					value: 16 / 9
				},
				{
					label: __("Free"),
					value: NaN
				}
			];
		}
	},
	methods: {
		crop_image() {
			this.file.crop_box_data = this.cropper.getData();
			const canvas = this.cropper.getCroppedCanvas();
			const file_type = this.file.file_obj.type;
			canvas.toBlob(blob => {
				var cropped_file_obj = new File([blob], this.file.name, {
					type: blob.type
				});
				this.file.file_obj = cropped_file_obj;
				this.$emit("toggle_image_cropper");
			}, file_type);
		}
	}
};

/* template */
var __vue_render__ = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", [
      _c("img", { ref: "image", attrs: { src: _vm.src, alt: _vm.file.name } })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "image-cropper-actions" }, [
      _c("div", [
        _vm.fixed_aspect_ratio == null
          ? _c(
              "div",
              { staticClass: "btn-group" },
              _vm._l(_vm.aspect_ratio_buttons, function(button) {
                return _c(
                  "button",
                  {
                    key: button.label,
                    staticClass: "btn btn-default btn-sm",
                    class: {
                      active: isNaN(_vm.aspect_ratio)
                        ? isNaN(button.value)
                        : button.value === _vm.aspect_ratio
                    },
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        _vm.aspect_ratio = button.value
                      }
                    }
                  },
                  [_vm._v("\n\t\t\t\t\t" + _vm._s(button.label) + "\n\t\t\t\t")]
                )
              }),
              0
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", [
        _vm.fixed_aspect_ratio == null
          ? _c(
              "button",
              {
                staticClass: "btn btn-sm margin-right",
                on: {
                  click: function($event) {
                    return _vm.$emit("toggle_image_cropper")
                  }
                }
              },
              [_vm._v("\n\t\t\t\t" + _vm._s(_vm.__("Back")) + "\n\t\t\t")]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-primary btn-sm",
            on: { click: _vm.crop_image }
          },
          [_vm._v("\n\t\t\t\t" + _vm._s(_vm.__("Crop")) + "\n\t\t\t")]
        )
      ])
    ])
  ])
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-07cb5b9d_0", { source: "\nimg {\n\tdisplay: block;\n\tmax-width: 100%;\n\tmax-height: 600px;\n}\n.image-cropper-actions {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tmargin-top: var(--margin-md);\n}\n", map: {"version":3,"sources":["frappe/public/js/frappe/file_uploader/ImageCropper.vue"],"names":[],"mappings":";AAwHA;CACA,cAAA;CACA,eAAA;CACA,iBAAA;AACA;AAEA;CACA,aAAA;CACA,mBAAA;CACA,8BAAA;CACA,4BAAA;AACA","file":"ImageCropper.vue","sourcesContent":["<template>\n\t<div>\n\t\t<div>\n\t\t\t<img ref=\"image\" :src=\"src\" :alt=\"file.name\" />\n\t\t</div>\n\t\t<div class=\"image-cropper-actions\">\n\t\t\t<div>\n\t\t\t\t<div class=\"btn-group\" v-if=\"fixed_aspect_ratio == null\">\n\t\t\t\t\t<button\n\t\t\t\t\t\tv-for=\"button in aspect_ratio_buttons\"\n\t\t\t\t\t\ttype=\"button\"\n\t\t\t\t\t\tclass=\"btn btn-default btn-sm\"\n\t\t\t\t\t\t:class=\"{\n\t\t\t\t\t\t\tactive: isNaN(aspect_ratio)\n\t\t\t\t\t\t\t\t? isNaN(button.value)\n\t\t\t\t\t\t\t\t: button.value === aspect_ratio\n\t\t\t\t\t\t}\"\n\t\t\t\t\t\t:key=\"button.label\"\n\t\t\t\t\t\t@click=\"aspect_ratio = button.value\"\n\t\t\t\t\t>\n\t\t\t\t\t\t{{ button.label }}\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div>\n\t\t\t\t<button\n\t\t\t\t\tclass=\"btn btn-sm margin-right\"\n\t\t\t\t\t@click=\"$emit('toggle_image_cropper')\"\n\t\t\t\t\tv-if=\"fixed_aspect_ratio == null\"\n\t\t\t\t>\n\t\t\t\t\t{{ __(\"Back\") }}\n\t\t\t\t</button>\n\t\t\t\t<button class=\"btn btn-primary btn-sm\" @click=\"crop_image\">\n\t\t\t\t\t{{ __(\"Crop\") }}\n\t\t\t\t</button>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</template>\n\n<script>\nimport Cropper from \"cropperjs\";\nexport default {\n\tname: \"ImageCropper\",\n\tprops: [\"file\", \"fixed_aspect_ratio\"],\n\tdata() {\n\t\tlet aspect_ratio =\n\t\t\tthis.fixed_aspect_ratio != null ? this.fixed_aspect_ratio : NaN;\n\t\treturn {\n\t\t\tsrc: null,\n\t\t\tcropper: null,\n\t\t\timage: null,\n\t\t\taspect_ratio\n\t\t};\n\t},\n\twatch: {\n\t\taspect_ratio(value) {\n\t\t\tif (this.cropper) {\n\t\t\t\tthis.cropper.setAspectRatio(value);\n\t\t\t}\n\t\t}\n\t},\n\tmounted() {\n\t\tif (window.FileReader) {\n\t\t\tlet fr = new FileReader();\n\t\t\tfr.onload = () => (this.src = fr.result);\n\t\t\tfr.readAsDataURL(this.file.cropper_file);\n\t\t}\n\t\tlet crop_box = this.file.crop_box_data;\n\t\tthis.image = this.$refs.image;\n\t\tthis.image.onload = () => {\n\t\t\tthis.cropper = new Cropper(this.image, {\n\t\t\t\tzoomable: false,\n\t\t\t\tscalable: false,\n\t\t\t\tviewMode: 1,\n\t\t\t\tdata: crop_box,\n\t\t\t\taspectRatio: this.aspect_ratio\n\t\t\t});\n\t\t\twindow.cropper = this.cropper;\n\t\t};\n\t},\n\tcomputed: {\n\t\taspect_ratio_buttons() {\n\t\t\treturn [\n\t\t\t\t{\n\t\t\t\t\tlabel: __(\"1:1\"),\n\t\t\t\t\tvalue: 1\n\t\t\t\t},\n\t\t\t\t{\n\t\t\t\t\tlabel: __(\"4:3\"),\n\t\t\t\t\tvalue: 4 / 3\n\t\t\t\t},\n\t\t\t\t{\n\t\t\t\t\tlabel: __(\"16:9\"),\n\t\t\t\t\tvalue: 16 / 9\n\t\t\t\t},\n\t\t\t\t{\n\t\t\t\t\tlabel: __(\"Free\"),\n\t\t\t\t\tvalue: NaN\n\t\t\t\t}\n\t\t\t];\n\t\t}\n\t},\n\tmethods: {\n\t\tcrop_image() {\n\t\t\tthis.file.crop_box_data = this.cropper.getData();\n\t\t\tconst canvas = this.cropper.getCroppedCanvas();\n\t\t\tconst file_type = this.file.file_obj.type;\n\t\t\tcanvas.toBlob(blob => {\n\t\t\t\tvar cropped_file_obj = new File([blob], this.file.name, {\n\t\t\t\t\ttype: blob.type\n\t\t\t\t});\n\t\t\t\tthis.file.file_obj = cropped_file_obj;\n\t\t\t\tthis.$emit(\"toggle_image_cropper\");\n\t\t\t}, file_type);\n\t\t}\n\t}\n};\n</script>\n<style>\nimg {\n\tdisplay: block;\n\tmax-width: 100%;\n\tmax-height: 600px;\n}\n\n.image-cropper-actions {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tmargin-top: var(--margin-md);\n}\n</style>\n"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "<template>\n\t<div>\n\t\t<div>\n\t\t\t<img ref=\"image\" :src=\"src\" :alt=\"file.name\" />\n\t\t</div>\n\t\t<div class=\"image-cropper-actions\">\n\t\t\t<div>\n\t\t\t\t<div class=\"btn-group\" v-if=\"fixed_aspect_ratio == null\">\n\t\t\t\t\t<button\n\t\t\t\t\t\tv-for=\"button in aspect_ratio_buttons\"\n\t\t\t\t\t\ttype=\"button\"\n\t\t\t\t\t\tclass=\"btn btn-default btn-sm\"\n\t\t\t\t\t\t:class=\"{\n\t\t\t\t\t\t\tactive: isNaN(aspect_ratio)\n\t\t\t\t\t\t\t\t? isNaN(button.value)\n\t\t\t\t\t\t\t\t: button.value === aspect_ratio\n\t\t\t\t\t\t}\"\n\t\t\t\t\t\t:key=\"button.label\"\n\t\t\t\t\t\t@click=\"aspect_ratio = button.value\"\n\t\t\t\t\t>\n\t\t\t\t\t\t{{ button.label }}\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div>\n\t\t\t\t<button\n\t\t\t\t\tclass=\"btn btn-sm margin-right\"\n\t\t\t\t\t@click=\"$emit('toggle_image_cropper')\"\n\t\t\t\t\tv-if=\"fixed_aspect_ratio == null\"\n\t\t\t\t>\n\t\t\t\t\t{{ __(\"Back\") }}\n\t\t\t\t</button>\n\t\t\t\t<button class=\"btn btn-primary btn-sm\" @click=\"crop_image\">\n\t\t\t\t\t{{ __(\"Crop\") }}\n\t\t\t\t</button>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</template>\n\n<script>\nimport Cropper from \"cropperjs\";\nexport default {\n\tname: \"ImageCropper\",\n\tprops: [\"file\", \"fixed_aspect_ratio\"],\n\tdata() {\n\t\tlet aspect_ratio =\n\t\t\tthis.fixed_aspect_ratio != null ? this.fixed_aspect_ratio : NaN;\n\t\treturn {\n\t\t\tsrc: null,\n\t\t\tcropper: null,\n\t\t\timage: null,\n\t\t\taspect_ratio\n\t\t};\n\t},\n\twatch: {\n\t\taspect_ratio(value) {\n\t\t\tif (this.cropper) {\n\t\t\t\tthis.cropper.setAspectRatio(value);\n\t\t\t}\n\t\t}\n\t},\n\tmounted() {\n\t\tif (window.FileReader) {\n\t\t\tlet fr = new FileReader();\n\t\t\tfr.onload = () => (this.src = fr.result);\n\t\t\tfr.readAsDataURL(this.file.cropper_file);\n\t\t}\n\t\tlet crop_box = this.file.crop_box_data;\n\t\tthis.image = this.$refs.image;\n\t\tthis.image.onload = () => {\n\t\t\tthis.cropper = new Cropper(this.image, {\n\t\t\t\tzoomable: false,\n\t\t\t\tscalable: false,\n\t\t\t\tviewMode: 1,\n\t\t\t\tdata: crop_box,\n\t\t\t\taspectRatio: this.aspect_ratio\n\t\t\t});\n\t\t\twindow.cropper = this.cropper;\n\t\t};\n\t},\n\tcomputed: {\n\t\taspect_ratio_buttons() {\n\t\t\treturn [\n\t\t\t\t{\n\t\t\t\t\tlabel: __(\"1:1\"),\n\t\t\t\t\tvalue: 1\n\t\t\t\t},\n\t\t\t\t{\n\t\t\t\t\tlabel: __(\"4:3\"),\n\t\t\t\t\tvalue: 4 / 3\n\t\t\t\t},\n\t\t\t\t{\n\t\t\t\t\tlabel: __(\"16:9\"),\n\t\t\t\t\tvalue: 16 / 9\n\t\t\t\t},\n\t\t\t\t{\n\t\t\t\t\tlabel: __(\"Free\"),\n\t\t\t\t\tvalue: NaN\n\t\t\t\t}\n\t\t\t];\n\t\t}\n\t},\n\tmethods: {\n\t\tcrop_image() {\n\t\t\tthis.file.crop_box_data = this.cropper.getData();\n\t\t\tconst canvas = this.cropper.getCroppedCanvas();\n\t\t\tconst file_type = this.file.file_obj.type;\n\t\t\tcanvas.toBlob(blob => {\n\t\t\t\tvar cropped_file_obj = new File([blob], this.file.name, {\n\t\t\t\t\ttype: blob.type\n\t\t\t\t});\n\t\t\t\tthis.file.file_obj = cropped_file_obj;\n\t\t\t\tthis.$emit(\"toggle_image_cropper\");\n\t\t\t}, file_type);\n\t\t}\n\t}\n};\n</script>\n<style>\nimg {\n\tdisplay: block;\n\tmax-width: 100%;\n\tmax-height: 600px;\n}\n\n.image-cropper-actions {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tmargin-top: var(--margin-md);\n}\n</style>\n"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__